class CategoryController {
  constructor() {
    this.name = 'category';
  }
}

export default CategoryController;



// WEBPACK FOOTER //
// ./client/app/components/category/category.controller.js